<template>
<div id="app">
    <router-view/>
    <span v-show="!stripe.isVisible">
        <div class="Overlay">
            <div class="Overlay-Background"></div>
            <div v-show="!beforeLoad">
                <a v-if="mode == 'Test'" href="#" class="TextLink Overlay-Badge--testMode Overlay-Badge--topRight">{{ mode }}</a>
                <div class="Overlay-Badge--bottomLeft"><span class="Overlay-BadgeImage"> Inspira </span></div>
            </div>
        </div>
    </span>
    <v-app id="inspire">
        <v-content>
            <v-container v-show="!stripe.isVisible">
                <v-layout fullscreen justify-center align-center>
                    <v-flex xs12 sm12 md6 mt-4>
                        <div v-show="beforeLoad">
                            <app-loader :beforeLoad="beforeLoad"/>
                        </div>
                        <div v-show="!beforeLoad && !success" >
                            <div v-show="!error">

                                <app-navbar :pending="pending" :title="title" :description="description" @close="closeIframe"/>
                                <app-stepper @paymentInfoData="handleProvider" @creditCardData="setCreditCard" @createSource="setCreateSource" @creditCardData_save="setCreditCardSave" @paymentProvider="setProvider" :pending="pending" :pay="pay" :button_name="button_name" />

                            </div>
                            <div v-show="error">
                                <app-error :error_message="errorMessage" :error_ping="error_ping" :pending="pending" :url_img="urlImage" @tryAgain="tryAgain" @useAnother="another" @cancel="closeIframe" />
                            </div>
                        </div>
                        <div v-show="success">
                            <app-success :fullName="fullName"  @cancel="handleSuccess" />
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</div>
</template>

<script>
import PaymentApiVariables from './resources/apijsons/payment/apiVariables.js'
import PaymentVariables from './resources/apijsons/payment/paymentVariables.js'
import { EventBus } from './components/EventBus.js'
import SuccessPage from './components/Success.vue'
import Stepper from './components/Stepper.vue'
import ErrorPage from './components/Error.vue'
import NavBar from './components/NavBar.vue'
import Loader from './components/Loader.vue'
import axios from 'axios'


export default {
    name: 'app',
    components: {
        'app-navbar': NavBar,
        'app-stepper': Stepper,
        'app-error': ErrorPage,
        'app-success': SuccessPage,
        'app-loader': Loader,
    },
    data() {
        return {
            description: '',
            title: '',
            pending: false,
            pay: true,
            step: 0,
            errorMessage: '',
            button_name: '',
            error: false,
            error_ping: false,
            beforeLoad: true,
            mode: 'Production',
            success: false,
            fullName: '',
            successData: '',
            timeOut: '',
            urlImage: '',
            provider: '',
            paymentMethod:'card',
            stripe: {
                isVisible: false,
                pk_key: '',
                name: '',
                icon: '',
            },
            tryAgainBtn: {
                customer: '',
                retry: true
            },
            ping: {
               test: false,
               language: "en",
               command: "VALIDATE_KEY",
               app_id: "1",
               apiLogin: "",
               apiKey: ""
           },
            payment_variables: PaymentApiVariables,
            payment_json: PaymentVariables,
        }
    },
    created() {
        //api check
        window.addEventListener('message', this.handlePing);
    },
    sockets: {
        connect() {
            // Fired when the socket connects.
            this.isConnected = true;
        },
    },
    methods: {
        handlePing(event) {
            let _this = this; //scope
            if(!event.data.hasOwnProperty('type')) {
                //set language
                if(event.data.hasOwnProperty('features')) {
                    console.log(`%cLanguage: ${event.data.features.language}`, 'color:red');
                    this.$i18n.locale = event.data.features.language !== 'pt' ? event.data.features.language : 'pt_BR';
                    axios.post(process.env.VUE_APP_GETCOUNTRIES,
                            _this.ping, {
                                headers: { 'Content-Type': 'application/json', }
                            }
                        )
                        .then(response => {
                            console.log(response.data.countries);
                                 EventBus.$emit('countries', this.$i18n.locale,response.data.countries);
                        })
                        .catch(error => {
                                //EventBus.$emit('countries', this.$i18n.locale);
                        });
                }

                if (event.data.merchant !== undefined) {
                    this.ping.language = event.data.features.language;
                    this.ping.app_id = event.data.merchant.app_id;
                    this.ping.apiKey = event.data.merchant.apiKey;
                    axios.post(process.env.VUE_APP_VALIDATE_KEY,
                            _this.ping, {
                                headers: { 'Content-Type': 'application/json', }
                            }
                        )
                        .then(response => {
                            console.log(response);
                            //set name stripe
                            _this.stripe.name = response.data.app_wallets.name;
                            //set url image and icon
                            _this.urlImage = response.data.app_wallets.logo_url ? response.data.app_wallets.logo_url:'' ;
                            _this.stripe.icon = response.data.app_wallets.icon_url;
                            //set stripe keys
                            _this.stripe.pk_key = response.data.pk_key;
                            if(response.data.appActive && response.data.app_wallets.active){
                                //SUSCRIBE TO THE CHANNEL WITH CAMUNDA ID
                                console.log('api key valid')
                                _this.handleCallerEvent(event, response);
                            } else { //appActive
                                _this.pingErrorStatus(); //show modal with error message
                            }
                        })
                        .catch(error => {
                            console.log('%cError','color:red');
                            console.log(error);
                            _this.pingErrorStatus();
                        });
                }
            }
        },
        handleOtherCountries() {
            console.log('handling other data');
            let _this = this; //scope
            let handler = StripeCheckout.configure({
                key: this.stripe.pk_key,
                image: this.stripe.icon,
                locale: this.$i18n.locale,
                token(token) {
                    _this.handleToken(token);
                },
                opened() {
                    //handle data when open iframe
                    console.log('stripe oppened');
                    _this.stripe.isVisible = true;
                },
                closed() {
                    //handle data when close iframe
                    console.log('stripe closed');
                    _this.beforeLoad = true;
                    setTimeout( () => {
                        _this.beforeLoad = false;
                        _this.stripe.isVisible = false;
                    },1500)

                    // _this.closeIframe();
                }
            });

            // Open Checkout with further options:
            handler.open({
                name: _this.stripe.name,
                email: this.payment_json.transaction.payer.emailAddress,
                description: this.payment_json.transaction.order.description,
                zipCode: false,
                amount: parseFloat(this.payment_json.transaction.order.additionalValues.TX_VALUE.value)*100
            });

            // Close Checkout on page navigation:
            window.addEventListener('popstate', function() {
                console.log('pop estate se cerro');
                handler.close();
            });
        },
        handleToken(token) {
           // You can access the token ID with `token.id`.
           // Get the token ID to your server-side code for use.
           let expMonth = token.card.exp_month<10?`0${token.card.exp_month}`:token.card.exp_month; //validation to add 0
           this.payment_json.transaction.creditCard.name = this.payment_json.transaction.payer.fullName;
           this.payment_json.transaction.creditCard.expirationDate = `${token.card.exp_year}/${expMonth}`;
           this.payment_json.transaction.paymentMethod = token.card.brand.toUpperCase();
           this.payment_json.transaction.creditCard.number = token.card.last4;
           this.payment_json.transaction.creditCardTokenId = token.id;
           this.post();
        },
        //preloaded information to fill out buyer and api information
        handleCallerEvent(event, app) {
            if (event.data.buyer !== undefined) {
                let data = event.data;
                let appInfo = app.data;

                //set language
                let language = data.features.language !== 'pt' ? data.features.language : 'pt_BR';
                this.$i18n.locale = language;

                //merchant id
                this.payment_variables.variables.apiKey.value = data.merchant.apiKey;
                this.payment_variables.variables.app_id.value = data.merchant.app_id;

                //device attributes
                this.mode = appInfo.live ? 'Production' : 'Test';
                this.payment_json.test = !appInfo.live; //if true send to production, else testing
                this.payment_json.transaction.deviceSessionId = data.merchant.deviceSessionId;
                this.payment_json.transaction.cookie = data.merchant.sessionid;
                this.handleSessions(data.merchant.deviceSessionId);

                //mode params
                this.payment_variables.variables.event.value = data.payment.mode; //api mode
                this.payment_variables.variables.charge_at.value = data.payment.charge_at; //api charge_at
                this.payment_json.transaction.order.description = data.payment.description;

                //buyer
                this.payment_json.transaction.order.buyer.fullName = data.buyer.name;
                this.payment_json.transaction.order.buyer.emailAddress = data.buyer.email;
                this.payment_json.transaction.order.buyer.merchantBuyerId = data.buyer.buyerId;
                this.payment_json.language = data.features.language;
                this.payment_json.transaction.paymentCountry = data.buyer.country;


                //currency
                this.payment_json.transaction.order.additionalValues.TX_VALUE.value = data.payment.amount;
                this.payment_json.transaction.order.additionalValues.TX_VALUE.currency = data.payment.currency;

                //form template 'form1'
                EventBus.$emit('callerData', {buyer: data.buyer});
               
                    
                //button name
                let mode = data.payment.mode === 'token_with_future_charge';
                let amount = mode ? '' : `${data.payment.amount} ${data.payment.currency}`;
                this.button_name = mode ? this.$t("message.add_card") : `${this.$t("message.pay")} ${amount}` ;
                this.title = mode ? this.$t("message.add_payment_method") : this.$t("message.payment_method");
                this.description = data.payment.description;

                EventBus.$emit('callerData_country', {buyer: data.buyer,wallet_id:appInfo.app_wallets.wallet_id,environment:appInfo.live ? 'production' : 'sandbox',mode:mode});
                
                setTimeout(() => {
                    this.beforeLoad = false;
                }, 900);
            }
        },
        handleSessions(session) {
            let scriptFraud = document.createElement('script');
            let noScript = document.createElement('noscript');
            let iframeFraud = document.createElement('iframe');

            scriptFraud.setAttribute('src',`https://maf.pagosonline.net/ws/fp/tags.js?id=${session}80200`);

            iframeFraud.setAttribute('src', `https://maf.pagosonline.net/ws/fp/tags.js?id=${session}80200`);
            iframeFraud.setAttribute('width', `100px`);
            iframeFraud.setAttribute('height', `100px`);
            iframeFraud.setAttribute('border', `0`);
            iframeFraud.setAttribute('position', `absolute`);
            iframeFraud.setAttribute('top', `-5000px`);
            noScript.append(iframeFraud);

            document.head.appendChild(scriptFraud);
            document.head.appendChild(noScript);

        },
        handleProvider(data, provider) {
            console.log(`%cProvider: ${provider}`, 'color:orange');
            this.provider = provider;
            this.setPaymentInfo(data);
            console.log(provider);
            if(provider === 'PAYU') {
                EventBus.$emit('nextStep');
            } else {
                this.handleOtherCountries();
            }
        },
         setProvider(provider) {
            console.log(`%cProvider: ${provider}`, 'color:orange');
            this.provider = provider;
         },
        setPaymentInfo(data, provider) {
            console.log('%cPayment info form', 'color:blue');
            this.payment_json.transaction.payer.fullName = data.payer.full_name;
            this.payment_json.transaction.payer.emailAddress = data.payer.email;
            this.payment_json.transaction.payer.contactPhone = data.payer.phone;
            this.payment_json.transaction.payer.merchantPayerId = data.payer.email;
            this.payment_json.transaction.payer.billingAddress.street1 = data.billing_address.street1;
            this.payment_json.transaction.payer.billingAddress.city = data.billing_address.city;
            this.payment_json.transaction.payer.billingAddress.country = data.billing_address.country;
            this.payment_json.transaction.payer.billingAddress.postalCode = data.billing_address.postal_code;
            this.setBuyerInfo()
        },
        setBuyerInfo() {
            console.log('%cBuyer info', 'color:blue');
            this.payment_json.transaction.order.buyer.contactPhone = this.payment_json.transaction.payer.contactPhone
            this.payment_json.transaction.order.buyer.shippingAddress.country = this.payment_json.transaction.payer.billingAddress.country;
            this.payment_json.transaction.order.buyer.shippingAddress.street1 = this.payment_json.transaction.payer.billingAddress.street1;
            this.payment_json.transaction.order.buyer.shippingAddress.city = this.payment_json.transaction.payer.billingAddress.city;
            this.payment_json.transaction.order.buyer.shippingAddress.postalCode = this.payment_json.transaction.payer.billingAddress.postalCode;
            this.setOtherCreditCard();
        },
        setCreditCard(data) {
            console.log('%cCredit card', 'color:blue');
            this.payment_json.transaction.creditCard.number = data.credit_card.number;
            this.payment_json.transaction.creditCard.securityCode = data.credit_card.security_code;
            this.payment_json.transaction.creditCard.expirationDate = data.credit_card.expiration_date;
            //fill out with existing data
            this.payment_json.transaction.paymentMethod = data.credit_card.paymentMethod;
            this.payment_json.transaction.paymentCountry = this.payment_json.transaction.payer.billingAddress.country;
            this.payment_json.transaction.creditCard.name = this.payment_json.transaction.payer.fullName;
            this.fullName = this.payment_json.transaction.payer.fullName;
            this.post();
        },
        setCreditCardSave(data){
            console.log('%cCredit card Save', 'color:blue');
            this.payment_json.transaction.creditCard.securityCode = data.security_code;
            //fill out with existing data
            this.payment_json.transaction.paymentMethod = data.valueCreditCard.paymentMethod;
            this.payment_json.transaction.paymentCountry = data.valueCreditCard.paymentCountry;
            this.payment_json.transaction.creditCardTokenId = data.valueCreditCard.creditCardTokenId;
            this.payment_json.transaction.creditCard.number = "save";
            this.payment_json.transaction.payer = data.valueCreditCard.payer;
            
            this.payment_json.transaction.order.buyer.contactPhone = this.payment_json.transaction.payer.contactPhone
            this.payment_json.transaction.order.buyer.shippingAddress.country = this.payment_json.transaction.payer.billingAddress.country;
            this.payment_json.transaction.order.buyer.shippingAddress.street1 = this.payment_json.transaction.payer.billingAddress.street1;
            this.payment_json.transaction.order.buyer.shippingAddress.city = this.payment_json.transaction.payer.billingAddress.city;
            this.payment_json.transaction.order.buyer.shippingAddress.postalCode = this.payment_json.transaction.payer.billingAddress.postalCode;

            this.fullName = this.payment_json.transaction.payer.fullName;
            this.post();
        },
        setCreateSource(paymentMethod,provider,expire = null,return_payment= null){
            console.log("createSource >>>>>");
            console.log(paymentMethod);
            console.log(provider);
            console.log(expire);
            this.provider = provider;
            this.paymentMethod = paymentMethod;
            if(expire!=null){
                this.payment_variables.variables = {...this.payment_variables.variables,TIME_EXPIRED: { "value":`PT${expire}H`, "type": "String" },return_payment:{ "value":return_payment != null ? return_payment: '' , "type": "String" }};
            }
            this.payment_variables.variables.event.value = "create_source_payment";
            this.payment_json.transaction.paymentMethod = paymentMethod;
            this.post();
            //EventBus.$emit('nextStep');

        },
        setOtherCreditCard() {
            this.payment_json.transaction.paymentCountry = this.payment_json.transaction.payer.billingAddress.country;
        },
        post() {
            console.log('%cPOST','color:green');
            this.payment_variables.variables = {...this.payment_variables.variables,paymentMethod: { "value":this.paymentMethod, "type": "String" }};

            // send object via post
            this.pending = true;
            let stringJson = JSON.stringify(this.payment_json);
            this.payment_variables.variables.content.value = stringJson;
            let _this = this;
            axios.post(process.env.VUE_APP_PROCESS_PAYMENT,
                    _this.payment_variables, {
                        headers: { 'Content-Type': 'application/json', }
                    }
                )
                .then(response => {
                    //SUSCRIBE TO THE CHANNEL WITH CAMUNDA ID
                    _this.sockets.subscribe(`payment.${response.data.id}`, (data) => {
                        _this.handleCamundaData(data, response.data.id);
                    });
                })
                .catch(error => {
                    console.log('%cError','color:red');
                    return error;
                });
        },
        tryAgain() {
            if(this.provider.toLowerCase() == 'stripe') {
                this.pending = true;
                //create new reference of the payment object
                let new_payment_json = {...this.payment_json};
                let new_payment_variables = {...this.payment_variables};
                //add two new variables of tryagain
                new_payment_json.customer = this.tryAgainBtn.customer;
                new_payment_json.retry = this.tryAgainBtn.retry;
                let stringJson = JSON.stringify(new_payment_json);
                new_payment_variables.variables.content.value = stringJson;
                let _this = this;
                axios.post(process.env.VUE_APP_PROCESS_PAYMENT,
                        new_payment_variables, {
                            headers: { 'Content-Type': 'application/json', }
                        }
                    )
                    .then(response => {
                        //SUSCRIBE TO THE CHANNEL WITH CAMUNDA ID
                        _this.sockets.subscribe(`payment.${response.data.id}`, (data) => {
                            _this.handleCamundaData(data, response.data.id);
                        });
                    })
                    .catch(error => {
                        console.log('%cError','color:red');
                        return error;
                    });
                } else {
                    this.post();
                }
        },
        // Callback from socket response
        handleCamundaData(data, camunda_id) {
            console.log('%cCAMUNDA DATA','color:red');
            console.log(data);
            let transactionResponse = JSON.parse(data.transactionResponse);
            let getProvider = this.provider.toLowerCase();
            const errorCode = new Set(['card_declined']); //car_declined has declined messages
            const transactionState = new Set(['APPROVED','PENDING','SUBMITTED']);
            console.log(transactionResponse);
            console.log(`%cProvider ${getProvider}`, `color:red;`);
            if (data.code === "SUCCESS") {
                if(!transactionState.has(transactionResponse.state)) {
                    this.tryAgainBtn.customer = transactionResponse.hasOwnProperty('customer') ? transactionResponse.customer : '';
                    // this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                    if(errorCode.has(transactionResponse.responseCode)) {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.decline_code}`));
                    } else if(getProvider == 'stripe') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.generic.${transactionResponse.responseCode}`));
                    } else if(getProvider == 'payu') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                    } else {
                        this.handleError(this.$t(`message.${transactionResponse.responseCode}`));
                    }
                }else if(getProvider == 'stripe' && transactionResponse.hasOwnProperty('qr_code_url')){
                     //unsuscribe from formed channel
                    this.sockets.unsubscribe(`payment.${camunda_id}`);
                    this.pending = false;
                     let _this = this;
                     EventBus.$emit('qr_code_url',{qr_code_url:transactionResponse.qr_code_url,amount:transactionResponse.sources.amount,currency:transactionResponse.sources.currency});
                     this.sockets.subscribe(`payment_charges.${camunda_id}`, (data) => {
                          console.log("subscribe >>>>>>>>>>>>>>>>");
                         console.log(data);
                        _this.handleCamundaData_source(data, camunda_id);
                    });  
                }else if(getProvider == 'stripe'  && transactionResponse.hasOwnProperty('sources') && transactionResponse.sources.hasOwnProperty('redirect')){  
                    this.sockets.unsubscribe(`payment.${camunda_id}`);
                    this.pending = false;
                    let _this = this;
                    let url = transactionResponse.sources.redirect.url;
                    this.centeredPopup(url,'AliPay','800','500','yes');
                    EventBus.$emit('nextStep');
                    this.pending = true;
                    this.timeOut = setTimeout(()=>{
                         this.pending = false;
                    }, 12000);
                    this.sockets.subscribe(`payment_charges.${camunda_id}`, (data) => {
                        _this.handleCamundaData_source(data, camunda_id);
                    });  
               } else if(getProvider == 'payu' && transactionResponse.hasOwnProperty('responseCode') && transactionResponse.responseCode == "PENDING_TRANSACTION_CONFIRMATION") {
                    this.sockets.unsubscribe(`payment.${camunda_id}`);
                    let url = transactionResponse.extraParameters.URL_PAYMENT_RECEIPT_HTML;
                    this.centeredPopup(url,'Payu','800','500','yes');
                    //EventBus.$emit('URL_PAYMENT_RECEIPT_PDF',transactionResponse.extraParameters.URL_PAYMENT_RECEIPT_PDF);
                    //EventBus.$emit('nextStep');
                    this.success = true;
                    this.pending = false;
                    this.sucessData = data;
                    this.timeOut = setTimeout(()=>{
                        this.handleSuccess();
                    }, 6000);
               } else {
                    //unsuscribe from formed channel
                    this.sockets.unsubscribe(`payment.${camunda_id}`);
                    //loader false to stop loading animation
                    this.success = true;
                    this.pending = false;
                    this.sucessData = data;
                    this.timeOut = setTimeout(()=>{
                        this.handleSuccess();
                    }, 6000);
                }
            } else {
                if(transactionResponse != null){
                    this.tryAgainBtn.customer = transactionResponse.hasOwnProperty('customer') ? transactionResponse.customer : '';
                    if(errorCode.has(transactionResponse.responseCode)) {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.decline_code}`));
                    } else if(getProvider == 'stripe') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.generic.${transactionResponse.responseCode}`));
                    } else if(getProvider == 'payu') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                    } else {
                        this.handleError(this.$t(`message.${transactionResponse.responseCode}`));
                    }
                }else{
                    this.handleError(data.error);
                }
            
            }
        },
        handleCamundaData_source(data, camunda_id) {
            console.log('%cCAMUNDA DATA SOURCE','color:red');
            console.log(data);
            let transactionResponse = JSON.parse(data.transactionResponse);
            let getProvider = this.provider.toLowerCase();
            const errorCode = new Set(['card_declined']); //car_declined has declined messages
            const transactionState = new Set(['APPROVED','PENDING','SUBMITTED','chargeable']);
            console.log(transactionResponse);
            console.log(`%cProvider ${getProvider}`, `color:red;`);
            if (data.code === "SUCCESS") {
                if(!transactionState.has(transactionResponse.state)) {
                    this.tryAgainBtn.customer = transactionResponse.hasOwnProperty('customer') ? transactionResponse.customer : '';
                    // this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                    if(errorCode.has(transactionResponse.responseCode)) {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.decline_code}`));
                    } else if(getProvider == 'stripe') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.generic.${transactionResponse.responseCode}`));
                    } else if(getProvider == 'payu') {
                        this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                    } else {
                        this.handleError(this.$t(`message.${transactionResponse.responseCode}`));
                    }
                }else{
                    //unsuscribe from formed channel
                    this.sockets.unsubscribe(`payment_charges.${camunda_id}`);
                    //loader false to stop loading animation
                    this.success = true;
                    this.pending = false;
                    this.sucessData = data;
                    this.timeOut = setTimeout(()=>{
                        this.handleSuccess();
                    }, 6000);
                }
            }else {
                this.tryAgainBtn.customer = transactionResponse.hasOwnProperty('customer') ? transactionResponse.customer : '';
                if(errorCode.has(transactionResponse.responseCode)) {
                    this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.decline_code}`));
                } else if(getProvider == 'stripe') {
                    this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.generic.${transactionResponse.responseCode}`));
                } else if(getProvider == 'payu') {
                    this.handleError(this.$t(`message.${getProvider}.${this.$i18n.locale}.message.${transactionResponse.responseCode}`));
                } else {
                    this.handleError(this.$t(`message.${transactionResponse.responseCode}`));
                }
            }
        },
        handleError(error) {
            this.error = true;
            this.errorMessage = error;
            setTimeout(()=>{ this.pending = false; },100);

        },
        handleSuccess() {
            console.log('handleSuccess');
            clearTimeout(this.timeOut); //stop timeout from camunda data
            window.parent.postMessage({action: 'response', data: this.sucessData}, "*");
            this.closeIframe();
        },
        resetIframe() {
            console.log('reset iframe')
            this.success = false;
            this.pending = false;
            this.error = false;
            EventBus.$emit('e1');
            this.beforeLoad = true;
            this.stripe.isVisible = false;
        },
        closeIframe() {
            this.resetIframe();
            window.parent.postMessage({ action: 'close' }, "*");
        },
        another() {
            this.error = false;
            EventBus.$emit('e1');
        },
        pingErrorStatus() {
            this.error_ping = true;
            this.error = true;
            setTimeout(() => {
                this.beforeLoad = false;
            }, 900);
        },
        centeredPopup(url,winName,w,h,scroll){
            let LeftPosition = (screen.width) ? (screen.width-w)/2 : 0;
            let TopPosition = (screen.height) ? (screen.height-h)/2 : 0;
            let settings ='height='+h+',width='+w+',top='+TopPosition+',left='+LeftPosition+',scrollbars='+scroll+',resizable'
            let popupWindow = window.open(url,winName,settings)
        }
    }
}
</script>

<style>
.Overlay,
.Overlay-Background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.Overlay-Background {
    background: rgba(0, 0, 0, 0.6);
    z-index: 0;
}

.Overlay-Badge--bottomLeft {
    position: fixed;
    bottom: 14px;
    left: 14px;
    color: white;
}

.Overlay-Badge--topRight {
    position: fixed;
    top: 14px;
    right: 14px;
    text-decoration: none !important;
    color: white;
    background-color: rgb(166, 195, 7);
    border-radius: 6px;
    padding: 0 2px;
}

.theme--light.application {
    background-color: #fafafa00 !important;
}
</style>
